import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

import { AuthResponse } from "./model/authResponse";
import { User } from "./model/user";
import { AuthService } from "./services/auth.service";
import { UsersService } from "./services/users.service";
import { ExportsService } from "./services/exports.service";

@Injectable()
export class UsersDataManager {
    constructor(
        private usersService: UsersService,
        private exportsService: ExportsService,
    ) {}

    public getRole(): String {
        return localStorage.getItem("role");
    }

    public setRole(role) {
        localStorage.setItem("role", role);
    }

    public getName(): String {
        return localStorage.getItem("name");
    }

    public setName(name) {
        localStorage.setItem("name", name);
    }

    public getOrganisation(): String {
        return localStorage.getItem("organisation");
    }

    public setOrganisation(organisation) {
        localStorage.setItem("organisation", organisation);
    }

    public getLoggedInUser(): Observable<User> {
        return this.usersService.getLoggedInUser();
    }

    public getLoggedInUserByToken(token): Observable<User> {
        return this.usersService.getLoggedInUserByToken(token);
    }

    public getAllUsers(filter = undefined): Observable<User[]> {
        return this.usersService.getAllUsers(filter);
    }

    public getUsersByOrganisationId(organisationId): Observable<User[]> {
        return this.usersService.getUsersByOrganisationId(organisationId);
    }

    public createAdmin(
        username: string,
        email: string,
        role: string,
        organisationId: string,
    ): Observable<User> {
        return this.usersService.createAdmin(
            username,
            email,
            role,
            organisationId,
        );
    }

    public createUser(
        username: string,
        email: string,
        role: string,
        organisationId: string,
        log_requests: boolean,
    ): Observable<User> {
        return this.usersService.createUser(
            username,
            email,
            role,
            organisationId,
            log_requests,
        );
    }

    public updateUserRole(id: string, role: string): Observable<User> {
        return this.usersService.updateUserRole(id, role);
    }

    public updateUser(id: string, user: User): Observable<User> {
        return this.usersService.updateUser(id, user);
    }

    public deleteUsers(ids: string[]): Observable<User> {
        return this.usersService.deleteUsers(ids);
    }

    public deleteUser(id: string): Observable<User> {
        return this.usersService.deleteUser(id);
    }

    public deleteTrainingProgressByUser(id: string): Observable<User> {
        return this.usersService.deleteTrainingProgressByUser(id);
    }

    public deleteTrainingProgressByUsers(ids: string[]): Observable<User> {
        return this.usersService.deleteTrainingProgressByUsers(ids);
    }

    public getUserById(id: string): Observable<User> {
        return this.usersService.getUserById(id);
    }

    public resendLogin(email: string): Observable<User> {
        return this.usersService.resendLogin(email);
    }

    public resetPassword(email: string): Observable<User> {
        return this.usersService.resetPassword(email);
    }

    public updateUserPassword(
        id: string,
        oldPassword: string,
        newPassword: string,
    ): Observable<User> {
        return this.usersService.updateUserPassword(
            id,
            oldPassword,
            newPassword,
        );
    }

    public exportUsers(organisation: string): Observable<any> {
        return this.exportsService.exportUsers(organisation);
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/users.datamanager.ts